<template>
	<div class="mdc-dialog mdc-new-dialog" data-mdc-auto-init="MDCDialog" style="z-index: 9999;">
		<div class="mdc-dialog__container" style="opacity:1; transform: scale(1);">
			<div class="mdc-dialog__surface" role="alertdialog" aria-modal="true" aria-labelledby="my-dialog-title"
				aria-describedby="my-dialog-content" style="max-width: calc(100vw - 80px);">
				<div class="mdc-dialog__content pdt-24 pdb-12" id="my-dialog-content">
					<div class="t-headline7 font-m pdb-16 l-spacing6 t-color-headlineBlack" v-if="!!alertTitle">
						{{alertTitle}}
					</div>
					<div class="t-body1 t-color-bodyGrayA font-r l-spacing48 mgb-4" v-html="alertContent">
					</div>
					<!-- <div class="d-flex mgb-8 align-items-center">
						<div class="t-body1 t-bodyGrayA font-r">이메일 :</div>
						<div class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline">support@brand.com
						</div>
					</div>
					<div class="d-flex mgb-8 align-items-center">
						<div class="t-body1 t-bodyGrayA font-r">문의처 :</div>
						<div class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline">02-9182-7364</div>
					</div> -->
				</div>
				<div class="mdc-dialog__actions">
					<button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="close" @click.prevent="onCancel" @keypress.prevent="onCancel" v-show="!!alertCancel && isConfirm" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-color-secondaryBtnText font-m">{{alertCancel}}</span>
					</button>
					<button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="accept" @click.prevent="onAccept" @keypress.prevent="onAccept" v-show="!!alertAccept" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-color-secondaryBtnText font-m">{{alertAccept}}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="mdc-dialog__scrim" style="opacity:1;"></div>
	</div>
</template>

<script>
/**
 * alert/confirm component
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCDialog} from '@material/dialog'
export default {
	data() {
		return {
			dialog: null,
			alertTitle: '',
			alertContent: '',
			alertCancel: 'cancel',
			alertAccept: 'confirm',
			resolved: null,
			rejected: null,
			isConfirm: false,
			acceptStatus: false,
		}
	},

	watch: {
		'$route': {
		   handler: function(to, from) {
		   }
		}
	},
	
	methods: {
		attachMaterial(el) {
			this.dialog = MDCDialog.attachTo(el)            
		},

		open(payload, isConfirm){
			return new Promise((resolve, reject) => {
				this.dialog.autoStackButtons = false
				this.alertTitle = payload.title
				this.alertContent = payload.content
				this.isConfirm = isConfirm
				this.resolved = resolve
				this.rejected = reject

				let currentURL = this.dialog.buttons_[0].baseURI.split('/')
				let partPathName = currentURL[4]

				if (payload.accept) {
					this.alertAccept = payload.accept
				} else {
					this.alertAccept = 'confirm'
				}

				if (payload.cancel) {
					this.alertCancel = payload.cancel
				} else {
					this.alertCancel = 'cancel'
				}

				if(partPathName === 'orderdetail') {
					document.querySelector(".mdc-dialog.mdc-new-dialog").classList.add("mdc-dialog--open");
				} else {
					document.body.classList.add('h-auto')
					this.dialog.open()
				}
			})
		},

		close() {
			this.dialog.listen('MDCDialog:closed', () => {
				if (this.acceptStatus === true) {
					this.acceptStatus = false
					this.resolved(true)
				} else {
					this.rejected(true)
				}
			})
			let currentURL = this.dialog.buttons_[0].baseURI.split('/')
			let partPathName = currentURL[4]
			if(partPathName === 'orderdetail'){
				document.querySelector(".mdc-dialog.mdc-new-dialog").classList.remove("mdc-dialog--open");
			} else {
				document.body.classList.remove('h-auto')
				this.dialog.close()
			}
		},

		onAccept() {
			this.acceptStatus = true
			let currentURL = this.dialog.buttons_[0].baseURI.split('/')
			let partPathName = currentURL[4]
			if(localStorage.getItem('paymentMethod')==='bank_transfer' && partPathName==='orderdetail'){
				localStorage.removeItem('paymentMethod')
				window.location =location.protocol + '//' + location.host+'/member/refundbank/'+currentURL[5]
			} else if((localStorage.getItem('paymentMethod')==='FREE' || localStorage.getItem('paymentMethod')==='paypal' || localStorage.getItem('paymentMethod')==='ESSENTIAL') && partPathName==='orderdetail') {
				localStorage.removeItem('paymentMethod')
				window.location =location.protocol + '//' + location.host+'/member/refund/'+currentURL[5]
			} else {
				this.close()
			}
		},

		onCancel() {
			this.acceptStatus = false
			this.close()
		}
	}
}
</script>
